import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

export const StudentEvolutionDashboard = ({ evolutionLogs, studentLevel }: { evolutionLogs: any[], studentLevel?: string }) => {
  if (!evolutionLogs || evolutionLogs.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#6B7280', background: 'white', borderRadius: '16px', border: '1px dashed #D1D5DB' }}>
        Nenhuma avaliação de desempenho registrada para este aluno.
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '24px' }}>
        {/* Radar Chart */}
        <div style={{ background: 'white', border: '1px solid #E5E7EB', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
          <h4 style={{ margin: '0 0 16px 0', fontSize: '16px', color: 'var(--text-dark)', display: 'flex', justifyContent: 'space-between' }}>
            Perfil de Jogador (Atual)
            {studentLevel && <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#6B7280', background: '#F3F4F6', padding: '4px 8px', borderRadius: '12px' }}>Nível: {studentLevel}</span>}
          </h4>
          {(() => {
             const latest = evolutionLogs[0];
             const techAvg = ((latest.techServe || 5) + (latest.techForehand || 5) + (latest.techBackhand || 5) + (latest.techReturn || 5) + (latest.techNetPlay || 5)) / 5;
             const tactAvg = ((latest.tactRally || 5) + (latest.tactSelection || 5) + (latest.tactPositioning || 5) + (latest.tactAdaptation || 5)) / 4;
             const physAvg = ((latest.physFootwork || 5) + (latest.physStamina || 5)) / 2;
             const mentalAvg = ((latest.mentalClutch || 5) + (latest.mentalFocus || 5)) / 2;
             const cogAvg = ((latest.cogGameReading || 5) + (latest.cogReaction || 5) + (latest.cogDecision || 5)) / 3;
             
             const radarData = [
               { subject: 'Técnico', A: Number(techAvg.toFixed(1)), fullMark: 10 },
               { subject: 'Tático', A: Number(tactAvg.toFixed(1)), fullMark: 10 },
               { subject: 'Cognitivo', A: Number(cogAvg.toFixed(1)), fullMark: 10 },
               { subject: 'Mental', A: Number(mentalAvg.toFixed(1)), fullMark: 10 },
               { subject: 'Físico', A: Number(physAvg.toFixed(1)), fullMark: 10 }
             ];

             return (
               <div style={{ height: '300px', width: '100%' }}>
                 <ResponsiveContainer width="100%" height="100%">
                    <RadarChart cx="50%" cy="50%" outerRadius="70%" data={radarData}>
                      <PolarGrid />
                      <PolarAngleAxis dataKey="subject" tick={{ fill: '#4B5563', fontSize: 12, fontWeight: 600 }} />
                      <PolarRadiusAxis angle={30} domain={[0, 10]} />
                      <Radar name="Desempenho" dataKey="A" stroke="#10B981" fill="#10B981" fillOpacity={0.5} />
                      <Tooltip />
                    </RadarChart>
                 </ResponsiveContainer>
               </div>
             );
          })()}
        </div>

        {/* Evolution Line Chart */}
        <div style={{ background: 'white', border: '1px solid #E5E7EB', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
           <h4 style={{ margin: '0 0 16px 0', fontSize: '16px', color: 'var(--text-dark)' }}>Evolução Geral (Linha do Tempo)</h4>
           {(() => {
               const lineData = [...evolutionLogs].reverse().map(log => {
                 const techAvg = ((log.techServe || 5) + (log.techForehand || 5) + (log.techBackhand || 5) + (log.techReturn || 5) + (log.techNetPlay || 5)) / 5;
                 const tactAvg = ((log.tactRally || 5) + (log.tactSelection || 5) + (log.tactPositioning || 5) + (log.tactAdaptation || 5)) / 4;
                 const physAvg = ((log.physFootwork || 5) + (log.physStamina || 5)) / 2;
                 const mentalAvg = ((log.mentalClutch || 5) + (log.mentalFocus || 5)) / 2;
                 const cogAvg = ((log.cogGameReading || 5) + (log.cogReaction || 5) + (log.cogDecision || 5)) / 3;
                 const generalAvg = (techAvg + tactAvg + mentalAvg + physAvg + cogAvg) / 5;
                 
                 return {
                   date: new Date(log.date).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }),
                   media: Number(generalAvg.toFixed(1))
                 };
               });

               return (
                 <div style={{ height: '300px', width: '100%' }}>
                   <ResponsiveContainer width="100%" height="100%">
                     <LineChart data={lineData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                       <CartesianGrid strokeDasharray="3 3" vertical={false} />
                       <XAxis dataKey="date" tick={{ fontSize: 12 }} />
                       <YAxis domain={[0, 10]} tick={{ fontSize: 12 }} />
                       <Tooltip />
                       <Line type="monotone" dataKey="media" name="Média Geral" stroke="#3B82F6" strokeWidth={3} dot={{ r: 4, fill: '#3B82F6' }} activeDot={{ r: 6 }} />
                     </LineChart>
                   </ResponsiveContainer>
                 </div>
               );
           })()}
        </div>
      </div>

      {/* Detalhamento por KPI */}
      <div style={{ background: 'white', border: '1px solid #E5E7EB', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
        <h4 style={{ margin: '0 0 16px 0', fontSize: '16px', color: 'var(--text-dark)' }}>Detalhamento por KPI (Última Avaliação)</h4>
        {(() => {
          const latest = evolutionLogs[0];
          const kpis = [
            { category: 'Técnico', color: '#10B981', items: [
                { name: 'Saque', value: latest.techServe || 0 },
                { name: 'Forehand', value: latest.techForehand || 0 },
                { name: 'Backhand', value: latest.techBackhand || 0 },
                { name: 'Devolução', value: latest.techReturn || 0 },
                { name: 'Voleio / Smash', value: latest.techNetPlay || 0 }
            ]},
            { category: 'Tático', color: '#3B82F6', items: [
                { name: 'Consistência', value: latest.tactRally || 0 },
                { name: 'Direcionamento', value: latest.tactSelection || 0 },
                { name: 'Tomada de Decisão', value: latest.tactPositioning || 0 },
                { name: 'Adaptabilidade', value: latest.tactAdaptation || 0 }
            ]},
            { category: 'Físico', color: '#F59E0B', items: [
                { name: 'Footwork', value: latest.physFootwork || 0 },
                { name: 'Resistência / Agilidade', value: latest.physStamina || 0 }
            ]},
            { category: 'Mental', color: '#8B5CF6', items: [
                { name: 'Foco e Concentração', value: latest.mentalFocus || 0 },
                { name: 'Resiliência', value: latest.mentalClutch || 0 }
            ]},
            { category: 'Cognitivo', color: '#EC4899', items: [
                { name: 'Leitura de Jogo e Antecipação', value: latest.cogGameReading || 0 },
                { name: 'Tempo de Reação', value: latest.cogReaction || 0 },
                { name: 'Tomada de Decisão (Pressão)', value: latest.cogDecision || 0 }
            ]}
          ];

          return (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '32px' }}>
              {kpis.map(cat => (
                <div key={cat.category}>
                  <h5 style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#4B5563', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: cat.color }} />
                    {cat.category}
                  </h5>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {cat.items.map(item => (
                      <div key={item.name}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '6px' }}>
                          <span style={{ color: '#374151', fontWeight: 500 }}>{item.name}</span>
                          <span style={{ color: cat.color, fontWeight: 700 }}>
                            {item.value} / 10 {studentLevel && <span style={{ fontSize: '11px', fontWeight: 'normal', color: '#6B7280', marginLeft: '4px' }}>({studentLevel})</span>}
                          </span>
                        </div>
                        <div style={{ height: '6px', background: '#F3F4F6', borderRadius: '4px', overflow: 'hidden' }}>
                          <div style={{ height: '100%', background: cat.color, width: `${(item.value / 10) * 100}%`, borderRadius: '4px' }} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          );
        })()}
      </div>

      {/* Timeline de Feedbacks */}
      <div style={{ background: 'white', border: '1px solid #E5E7EB', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
        <h4 style={{ margin: '0 0 16px 0', fontSize: '16px', color: 'var(--text-dark)' }}>Histórico de Feedbacks</h4>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {evolutionLogs.filter(l => l.generalFeedback).slice(0, 5).map(log => (
            <div key={log.id} style={{ padding: '16px', background: '#F9FAFB', borderRadius: '12px', borderLeft: '4px solid #60A5FA' }}>
              <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '8px', fontWeight: 600 }}>{new Date(log.date).toLocaleDateString('pt-BR')}</div>
              <div style={{ fontSize: '14px', color: '#374151', lineHeight: '1.5' }}>"{log.generalFeedback}"</div>
            </div>
          ))}
          {evolutionLogs.filter(l => l.generalFeedback).length === 0 && (
            <div style={{ fontSize: '14px', color: '#6B7280' }}>Nenhum comentário registrado ainda.</div>
          )}
        </div>
      </div>

    </div>
  );
};
